export const Exchange_Enums = 
Object.freeze ({
    SportBook: 'SportBook',
    Exchange: 'Exchange',
    Empty: ''
});